export enum StaticLinkNatureRelationEnum {
  DIRECT_OWNERSHIP = "DIRECT_OWNERSHIP",
  INDIRECT_OWNERSHIP = "INDIRECT_OWNERSHIP",
  VOTING_RIGHTS = "VOTING_RIGHTS",
  BARE_OWNERSHIP = "BARE_OWNERSHIP",
  USUFRUCTUARY = "USUFRUCTUARY",
  LEGAL_REPRESENTATIVE = "LEGAL_REPRESENTATIVE",
  TRUSTEE = "TRUSTEE",
  TRUST_PROTECTOR = "TRUST_PROTECTOR",
  SETTLOR = "SETTLOR",
  TRUST_BENEFICIARY = "TRUST_BENEFICIARY",
  ASSOCIATIVE_STRUCTURE = "ASSOCIATIVE_STRUCTURE",
  BONDHOLDER = "BONDHOLDER",
  OTHER = "OTHER"
}

// Do not need PartialRecord as we implement every enum's keys
// Link with src\services\sint\identity\types.ts in bitbang
export type StaticLinkNatureRelationList = Record<
  StaticLinkNatureRelationEnum,
  { content_fr: string; content_en: string }
>;

export const staticLinkNatureRelation: StaticLinkNatureRelationList = {
  DIRECT_OWNERSHIP: { content_fr: "Détention directe", content_en: "Direct ownership" },
  INDIRECT_OWNERSHIP: { content_fr: "Détention indirecte", content_en: "Indirect ownership" },
  VOTING_RIGHTS: { content_fr: "Droits de vote", content_en: "Voting rights" },
  BARE_OWNERSHIP: { content_fr: "Nue-propriété", content_en: "Bare ownership" },
  USUFRUCTUARY: { content_fr: "Usufruitier", content_en: "Usufructuary" },
  LEGAL_REPRESENTATIVE: { content_fr: "Représentant légal", content_en: "Legal representative" },
  TRUSTEE: { content_fr: "Fiduciaire", content_en: "Trustee" },
  TRUST_PROTECTOR: { content_fr: "Fiduciant", content_en: "Trust Protector" },
  SETTLOR: { content_fr: "Constituant", content_en: "Settlor" },
  TRUST_BENEFICIARY: {
    content_en: "Trust Beneficiary",
    content_fr: "Bénéficiaire de fiducie"
  },
  ASSOCIATIVE_STRUCTURE: {
    content_fr: "Structure associative",
    content_en: "Associative structure"
  },
  BONDHOLDER: { content_fr: "Obligataire", content_en: "Bondholder" },
  OTHER: { content_fr: "Autres : préciser", content_en: "Other : please specify" }
};
